const limit: any = {
  thickness: 50,
  round: 100,
};

export default limit;
